import {
  Match,
  Show,
  Switch,
  createEffect,
  createSignal,
  on,
  onCleanup,
  onMount,
} from "solid-js";

import { GetUserPayChannelV2 } from "@/api/clientApi/wallet.ts";
import { Button } from "@/components/Base/Button/Button";
import Popup from "@/components/Base/Popup/Popup";
import Icon from "@/components/Icon";
import { useRouter } from "@/hooks/useRouter";
import { t } from "@/i18n";
import { formatToBindPoint, isFiat } from "@/lib/pointUtils";
import { getImgurl } from "@/lib/resFolder.ts";
import { cn } from "@/lib/tailwindcssTool.ts";
import { renderInnerHtml } from "@/lib/utils";
import { getCryptoIcon } from "@/stores/cryptoStore";
import { getVipItem } from "@/stores/depositStore.tsx";
import { sysConfigStore } from "@/stores/sysConfigStore.ts";
import { getUserInfo, isLogin, userStore } from "@/stores/userStore";
import {
  bindCashCode,
  bindTotalPoint,
  walletStore,
} from "@/stores/walletStore";

export default function HeaderWallet(props: { downloadAppBarHeight: number }) {
  const [isDrawerOpen, setIsDrawerOpen] = createSignal(false);
  const [isDirectionOpen, setIsDirectionOpen] = createSignal(false);
  // 活动和道具间不比较
  const [displayAmount, setDisplayAmount] = createSignal<string | null>(null);
  const { push, toDeposit, location } = useRouter();

  let popupRef: { handleClose: () => void } | undefined;

  const handleCurrency = () => {
    setIsDirectionOpen(!isDirectionOpen());
    if (!isDrawerOpen()) {
      setIsDrawerOpen(!isDrawerOpen());
      getUserInfo();
    } else {
      if (popupRef) {
        popupRef.handleClose();
      }
    }
  };
  let dropdownRef: HTMLElement;
  const handleOutsideClick = (e: MouseEvent) => {
    if (!isDrawerOpen()) return;
    const target = e.target as Node;
    if (dropdownRef && !dropdownRef.contains(target)) {
      if (popupRef) {
        popupRef.handleClose();
      } else {
        setIsDrawerOpen(false);
      }
      setIsDirectionOpen(false);
    }
  };
  onMount(() => {
    document.addEventListener("click", handleOutsideClick);
  });

  onCleanup(() => {
    document.removeEventListener("click", handleOutsideClick);
  });

  // onMount(() => {
  //   getDepositReward();
  // });
  createEffect(
    on(
      () => userStore.isLogin,
      () => {
        getDepositReward();
      },
      // {
      //   defer: true,
      // },
    ),
  );

  const getDepositReward = async () => {
    const res = await GetUserPayChannelV2({
      point_type: sysConfigStore.point_type,
    });
    if (res) {
      if (res?.discount?.activity_list) {
        res?.discount?.activity_list.map((item) => {
          if ([65].includes(item.atype)) {
            const vip_level = userStore.userInfo?.UserVip?.vip_level;
            const vipItem = getVipItem(
              item?.activity_config?.vip_cfg,
              vip_level,
            );
            // 匹配等级
            if (!vipItem) {
              item.result = "0";
              return item;
            }
            const activityItem =
              vipItem?.reward_cfg?.[vipItem?.reward_cfg.length - 1];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          } else if ([13].includes(item.atype)) {
            const activityItem =
              item?.activity_config?.list?.[
                item?.activity_config?.list.length - 1
              ];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          } else {
            const activityItem =
              item?.activity_config?.list?.[
                item?.activity_config?.list.length - 1
              ];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          }
        });
      }
      if (res?.discount?.promoitem_list) {
        const promoitem_list = res.discount?.promoitem_list;
        const resultProp = promoitem_list?.[0];
        const cfg_data = JSON.parse(resultProp.cfg_data);
        const config = JSON.parse(cfg_data?.config);
        // const item_lang = JSON.parse(cfg_data?.item_lang);
        const detail = config?.reward_list[0];
        if (config?.reward_type === 0) {
          setDisplayAmount(
            formatToBindPoint({
              value: detail?.value,
              pointType: sysConfigStore.point_type,
              showSymbol: true,
              bDeleteZeroPoint: true,
            }),
          );
        } else {
          setDisplayAmount(`${detail?.value / 10000}%`);
        }
      }
    }
  };

  return (
    <Show when={userStore.pointType} fallback={<></>}>
      <div class="relative" ref={(el) => (dropdownRef = el)}>
        <div
          id="h5-wallet-dropdown-trigger"
          class="flex h-[41px] items-center gap-2 rounded-[var(--md)] bg-[var(--colors-surface-bg-7)] p-1"
        >
          <div class="flex h-full items-center" onClick={handleCurrency}>
            <Icon name="money/fiat_BRL" class="size-[14px]" />
            <div class="ml-1 mr-[2px] font-['Alexandria']">
              <div class="mb-[2px] text-[12px] font-semibold text-[var(--colors-text-primary)]">
                {formatToBindPoint({
                  value: walletStore.selectedWallet?.point,
                  pointType: userStore.pointType || 0,
                  showSymbol: false,
                  isFiatPoint: isFiat(userStore.pointType || 0),
                })}
              </div>
              {/* <div class="text-[10px] font-semibold leading-[10px] text-[var(--colors-text-warning)]">
                {formatToBindPoint({
                  value: walletStore.selectedWallet?.bonus,
                  pointType: userStore.pointType || 0,
                  showSymbol: false,
                  isFiatPoint: isFiat(userStore.pointType || 0),
                })}
              </div> */}
            </div>
            <Icon
              name="general/angle-down_2"
              class="size-[14px] text-[var(--colors-icon-invert-btn)]"
            />
          </div>
          <Button
            variant={"primary"}
            class="bg-main-linear h-[33px] rounded-[var(--md)] border-[1px] border-[var(--colors-btn-border-default)] px-3 text-[var(--colors-text-brand)]"
            onClick={() => toDeposit()}
          >
            <span class="text-[13px] font-bold leading-[13px] text-[var(--colors-text-brand)]">
              {t("affiliate.deposit")}
            </span>
            <Show
              when={displayAmount() && !location.pathname.includes("/game")}
              fallback={<></>}
            >
              <div class="absolute top-[38px] ml-[-48px]">
                <img
                  src={getImgurl(`top-1.png`, "common/home/deposit-act")}
                  class={cn("h-[42px] w-[141px] shrink-0")}
                />
                <span class="text-general-light absolute ml-[-34px] mt-[-23px] w-[95px] text-center text-[12px] font-bold">
                  {t("deposit.max_bonus", {
                    val: displayAmount() || "",
                  })}
                </span>
              </div>
            </Show>
          </Button>
        </div>

        {/* Wallet popup using top-sliding Popup component */}
        <Popup
          show={isDrawerOpen()}
          onClose={() => setIsDrawerOpen(false)}
          direction="top"
          withHeader={false}
          zIndex={49}
          offset={57 + (isLogin() ? props.downloadAppBarHeight : 0)}
          withPadding={false}
          contentClass="max-h-[400px]"
          ref={(ref) => (popupRef = ref)}
        >
          <div class="bg-general-bg3 flex flex-col gap-[10px] overflow-y-auto rounded-b-[10px] px-[12px] pb-[15px] pt-[10px] shadow-lg">
            {/* PC版本的Points部分 */}
            {/* onclick={() => {
                document.body.style.overflow = "hidden";
                push("bonus-rule");
                setIsDrawerOpen(false);
              }} */}
            <div class="flex h-[15px] items-center gap-[4px]">
              <img
                src={getCryptoIcon(userStore.userInfo?.default_point_type || 0)}
                class="h-[20px] w-[20px]"
                alt="crypto_icon"
              />
              <span class="text-general-light text-[12px] font-[600] leading-normal">
                {t("common.balance")}
              </span>
              {/* <div class="cursor-pointer">
                <Icon name="exclamation-mark1" class="size-[14px]" />
              </div> */}
            </div>

            <div class="border-1 border-general-sk flex items-center justify-center rounded-[8px] border-dashed py-[11px]">
              <div class="flex flex-col">
                <span class="text-general-money text-center text-[22px] font-[600] leading-normal">
                  {bindTotalPoint()}
                </span>
                <Switch>
                  <Match when={!!walletStore.selectedWallet?.code}>
                    <div
                      class="text-general-darkzi text-center text-[12px] font-medium"
                      innerHTML={`<span>${t("wallet.bet_can_withdraw", {
                        val: renderInnerHtml(
                          bindCashCode(),
                          "text-general-light",
                        ),
                      })}</span>`}
                    ></div>
                  </Match>
                  <Match when={!walletStore.selectedWallet?.code}>
                    <div class="text-general-darkzi text-center text-[12px] font-medium">
                      {t("wallet.withdraw_anytime")}
                    </div>
                  </Match>
                </Switch>
                {/* <Switch>
                  <Match when={walletStore.pointStatus === "rollover"}>
                    <span class="text-general-darkzi text-[12px] font-[500] leading-normal">
                      {t("betmatch.wager")}{" "}
                      <span class="text-general-light text-[13px]">
                        {getCurPointSymbol()}
                        {formatToBindPoint({
                          value: walletStore.selectedWallet?.bonusCode,
                          pointType: walletStore.selectedWallet?.pointType || 0,
                          showSymbol: false,
                          isFiatPoint: isFiat(
                            walletStore.selectedWallet?.pointType || 0,
                          ),
                        })}{" "}
                      </span>
                      {t("withdraw.redeemablepoints")}
                    </span>
                  </Match>
                  <Match when={walletStore.pointStatus === "redeemable"}>
                    <span class="text-general-darkzi text-[12px] font-[500] leading-normal">
                      {t("withdraw.points_redeemable_tip")}
                    </span>
                  </Match>
                  <Match when={walletStore.pointStatus === "none"}>
                    <span class="text-general-darkzi text-[12px] font-[500] leading-normal">
                      {t("withdraw.earn_points_event_tip")}
                    </span>
                  </Match>
                </Switch> */}
              </div>
            </div>

            <div
              onclick={() => {
                push("/wallet/rollover");
                setIsDrawerOpen(false);
              }}
              class="bg-general-tmd10 flex h-[36px] items-center justify-center gap-[6px] rounded-[8px]"
            >
              <div class="flex items-center gap-1">
                <span class="text-general-light text-[12px] font-[500] leading-normal">
                  {t("withdraw.rollover_details")}
                </span>
                <Icon
                  name="double-chevron"
                  class="text-general-light size-[12px]"
                />
              </div>
              {/* <Switch>
                <Match when={walletStore.pointStatus === "rollover"}>
                  <div
                    class="flex items-center gap-1"
                    onclick={() => {
                      push("/wallet/rollover");
                      setIsDrawerOpen(false);
                    }}
                  >
                    <span class="text-general-light text-[12px] font-[500] leading-normal">
                      {t("withdraw.rollover_details")}
                    </span>
                    <Icon
                      name="double-chevron"
                      class="text-general-light size-[12px]"
                    />
                  </div>
                </Match>
                <Match when={walletStore.pointStatus === "redeemable"}>
                  <div
                    class="flex items-center gap-1"
                    onclick={() => {
                      push("bonus-center");
                      setIsDrawerOpen(false);
                    }}
                  >
                    <span class="text-general-highbut text-[12px] font-[500] leading-normal">
                      {t("withdraw.points_redeemable_now")}
                    </span>
                    <Icon
                      name="double-chevron"
                      class="text-general-highbut size-[12px]"
                    />
                  </div>
                </Match>
                <Match when={walletStore.pointStatus === "none"}>
                  <div
                    class="flex items-center gap-1"
                    onclick={() => {
                      push("bonus-center");
                      setIsDrawerOpen(false);
                    }}
                  >
                    <span class="text-general-light text-[12px] font-[500] leading-normal">
                      {t("withdraw.earn_points")}
                    </span>
                    <Icon
                      name="double-chevron"
                      class="text-general-light size-[12px]"
                    />
                  </div>
                </Match>
              </Switch> */}
            </div>
          </div>
        </Popup>
      </div>
    </Show>
  );
}
